

const ImportModals = () => {
    return (
        <div id={'base-box-all-modals'}>

        </div>
    );
}

export default ImportModals;
